export default __webpack_public_path__ + "static/media/level_5.ef783e33.png";